import { FeatureFlagConfig } from './types';

/**
 * Feature flag definitions
 * Add new feature flags here with their default values and descriptions
 */
export const FEATURE_FLAGS: FeatureFlagConfig = {
  // UI/UX Features
  ENROLL_USER: {
    key: 'ENROLL_USER',
    defaultValue: false,
    description: 'Enable user enrollment',
    category: 'UI',
  },
  NEW_SIGNUP_FLOW: {
    key: 'NEW_SIGNUP_FLOW',
    defaultValue: false,
    description: 'Allow users to sign up for new accounts',
    category: 'UI',
  },

  // Meeting Features
  NOT_CONSENTED_FILTERING: {
    key: 'NOT_CONSENTED_FILTERING',
    defaultValue: true,
    description: 'Show consented/not consented toggle in participant list',
    category: 'Meeting',
  },
  ZOOM_COMPANION_OAUTH: {
    key: 'ZOOM_COMPANION_OAUTH',
    defaultValue: false,
    description:
      'Zoom companion: connect Zoom via in-client OAuth (reload after toggling)',
    category: 'Meeting',
  },

  // Admin Features
  FUZZY_MATCH_ENROLLMENT: {
    key: 'FUZZY_MATCH_ENROLLMENT',
    defaultValue: false,
    description: 'Enable fuzzy match enrollment feature',
    category: 'Admin',
  },

  // Developer Tools
  FAKE_PARTICIPANTS: {
    key: 'FAKE_PARTICIPANTS',
    defaultValue: false,
    description: 'Enable fake participants generator panel for stress testing',
    category: 'Dev',
  },
  DEV_RISK_CONTROLS: {
    key: 'DEV_RISK_CONTROLS',
    defaultValue: false,
    description: 'Enable per-participant risk override controls',
    category: 'Dev',
  },
};

/**
 * Local storage key for feature flags
 */
export const FEATURE_FLAGS_STORAGE_KEY = 'pulse_feature_flags';

/**
 * Query parameter name for feature flag updates
 */
export const FEATURE_FLAG_QUERY_PARAM = 'ff';

/**
 * Categories for organizing feature flags
 */
export const FEATURE_FLAG_CATEGORIES = {
  UI: 'UI/UX',
  Meeting: 'Meeting',
  Admin: 'Admin',
  Dev: 'Developer Tools',
} as const;
